import React from 'react'
import cx from 'classnames'
import { useCallback, useMemo } from 'sb-hooks'

import Text from 'components/_new/typography/Text/Text'
import { Button } from 'components/_new/controls'
import { Box } from 'components/_new/layout'

import messages from './messages'
import s from './OffersItem.scss'


export const offerTitles = [ 'subscription', 'card', 'giftSubscription' ] as const

export type OffersItemProps = {
  size: number
  price: string // TODO check why this is "string" - added on 7/27/20 by pavelivanov
  title?: string
  offerTitle?: keyof typeof offerTitles // if you need new title, add to messages and us offerTitle
  discount?: string
  planName?: string
  buttonId?: string
  isBest?: boolean
  isSelected?: boolean
  onChoose: (values: { size: number, price: string, title: string, planName: string }) => void
}

const OffersItem: React.FunctionComponent<OffersItemProps> = (props) => {
  const {
    size, price, title, offerTitle = 'giftSubscription', discount = '0', planName, buttonId,
    isBest, isSelected,
    onChoose,
  } = props

  const handleButtonClick = useCallback(() => {
    onChoose({ size, price, title, planName })
  }, [ size, price, title, planName ])

  const rootClassName = cx(s.container, {
    [s.best]: isBest,
  })

  const bestId = `${buttonId}Best`
  const descriptionId = `${buttonId}Description`

  const titleMessage = useMemo(() => ({
    ...messages.titles[offerTitle],
    values: { size },
  }), [ size, offerTitle ])

  const discountMessage = useMemo(() => ({
    ...messages.discount,
    values: { discount },
  }), [ discount ])

  const buttonTitle = useMemo(() => {
    if (isSelected) {
      return messages.selectedButtonTitle
    }

    return messages.buttonTitle
  }, [ isSelected ])

  return (
    <div className={rootClassName} role="group">
      {
        isBest && (
          <div className={s.bestseller} id={bestId} aria-hidden>
            <Text tag="span" message={messages.bestseller} />
          </div>
        )
      }
      <div className={s.content} id={descriptionId} aria-hidden>
        <Text message={titleMessage} uppercase />
        <div className={s.price}>${price}</div>
        <Box mt={24}>
          <Text message={messages.hint} size="14-24" color="gray" />
        </Box>
        {
          Boolean(discount && parseInt(discount, 10)) && (
            <Box mt={4}>
              <Text message={discountMessage} color="brand" size="14-24" />
            </Box>
          )
        }
      </div>
      <Box mt={24}>
        <Button
          id={buttonId}
          title={buttonTitle}
          size="sm"
          color="brand"
          fullWidth
          disabled={isSelected}
          ariaDescribedBy={`${bestId} ${descriptionId}`}
          onClick={handleButtonClick}
        />
      </Box>
    </div>
  )
}


export default OffersItem
